export default __webpack_public_path__ + "static/media/range-arrow.7fe5874f.svg";